import { useCartDetailsAction } from "src/Views/Application/actions";
import useSession from "src/Hooks/useSession";
import { useMemo } from "react";

export function compareByStatus(a, b) {
  const statusOrder = ["AVAILABLE", "SOLD OUT"];

  const statusA = a.item_status;
  const statusB = b.item_status;

  const indexA = statusOrder.indexOf(statusA);
  const indexB = statusOrder.indexOf(statusB);

  if (indexA < indexB) {
    return -1;
  }
  if (indexA > indexB) {
    return 1;
  }
  return 0;
}
export const getSortedMenuCategoriesAndItems = (response) => {
  return response
    ?.sort((a, b) => a.menu_sort_order - b.menu_sort_order)
    ?.map((menu) => ({
      ...menu,
      category_item_response_beans: menu.category_item_response_beans
        ?.sort(
          (a, b) =>
            a.category?.category_sort_order - b.category?.category_sort_order
        )
        ?.map((category) => ({
          ...category,
          item_list: category.item_list?.sort(
            (a, b) => a?.item_sort_order - b?.item_sort_order
          ),
        })),
    }));
};

export function getUpdatedCartItemAddonQuantity({
  addons,
  itemQuantity,
  updatedItemQuantity,
  cartAddedAddons,
  cartItemDetails,
}) {
  let error = null;
  let res = addons?.map((addon) => {
    let updatedAddonQuantity =
      (addon?.addon_quantity / itemQuantity) * updatedItemQuantity;
    let curAddon = cartAddedAddons?.find(
      (add) => add?.addon_id === addon?.addon_id
    );
    if (
      updatedAddonQuantity - addon?.addon_quantity <=
        curAddon?.quantity -
          getAddonQuantityInCart(curAddon, cartItemDetails) ||
      curAddon?.is_negative_sale
    ) {
      return {
        addon_id: addon?.addon_id,
        addon_type: addon?.addon_type,
        addon_quantity: updatedAddonQuantity,
      };
    } else {
      error = { exceedQuantity: curAddon };
      return {};
    }
  });
  return error ? error : res;
}

export function getReducedAddons(addons) {
  return addons?.reduce((pre, cur) => {
    let addonInd = pre?.findIndex((addon) => addon?.addon_id === cur?.addon_id);
    if (addonInd !== -1) {
      pre[addonInd] = {
        ...pre[addonInd],
        addon_quantity: pre[addonInd]?.addon_quantity + 1,
      };
    } else {
      pre.push({
        ...cur,
        addon_quantity: 1,
      });
    }
    return pre;
  }, []);
}

export function getExpandedAddons(addons) {
  return addons?.reduce((pre, cur) => {
    for (let i = 0; i < cur?.addon_quantity; i++) {
      const addon = Object.assign({}, cur);
      let addonCost =
        !cur?.addon_cost && (cur?.sub_total || cur?.sub_total === 0)
          ? parseFloat(cur?.sub_total) / parseFloat(cur?.addon_quantity)
          : cur?.addon_cost;
      delete addon.addon_quantity;
      pre.push({ ...addon, addon_cost: addonCost });
    }
    return pre;
  }, []);
}

export function getUpdatedItemAddonQuantity({
  addons = [],
  itemQuantity,
  updatedItemQuantity,
  cartAddedAddons,
}) {
  let error = null;
  let reducedAddons = getReducedAddons(addons);

  reducedAddons = reducedAddons?.map((add) => {
    let curAddon =
      cartAddedAddons?.find((addon) => add?.addon_id === addon?.addon_id) ||
      add;
    let updatedAddonQuantity =
      (add?.addon_quantity / itemQuantity) * updatedItemQuantity;
    if (
      updatedAddonQuantity <= curAddon?.quantity ||
      curAddon?.is_negative_sale
    ) {
      return { ...add, addon_quantity: updatedAddonQuantity };
    } else {
      error = { exceedQuantity: curAddon || true };
      return {};
    }
  });

  let expandedAddons = getExpandedAddons(reducedAddons);

  return error ? error : expandedAddons;
}

export function iconExists(url) {
  let image = new Image();
  let url_image = url;
  image.src = url_image;
  return image.width !== 0;
}

export function checkAddonCategoryMin(addonCategoryList, addedAddons) {
  let error = null;
  addonCategoryList?.some((category) => {
    let addedCategoryAddons = addedAddons?.filter(
      (addon) => addon?.addon_category_id === category?.category_id
    );
    if (category?.minimum > addedCategoryAddons?.length) {
      error = category;
    }
    return category?.minimum > addedCategoryAddons?.length;
  });
  return error;
}

export function getLinkedItemQuantityInCart(item, cartItemDetails) {
  let addonInCart = cartItemDetails?.reduce((pre, cur) => {
    if (cur?.is_combo) {
      let addonInComboItems = cur?.combo_items?.reduce((prev, curr) => {
        if (curr?.addons) {
          let addonInCurComboItem = curr?.addons?.filter(
            (add) => add?.linked_item_id === item?.item_id
          );
          prev = prev.concat(addonInCurComboItem);
        }
        return prev;
      }, []);
      pre = pre.concat(addonInComboItems);
    } else {
      if (cur?.addons) {
        let addonInCurItem = cur?.addons?.filter(
          (add) => add?.linked_item_id === item?.item_id
        );
        pre = pre.concat(addonInCurItem);
      }
    }
    return pre;
  }, []);

  let addonQuantityInCart =
    addonInCart?.reduce((pre, cur) => {
      pre = pre + cur?.addon_quantity;
      return pre;
    }, 0) || 0;

  return addonQuantityInCart;
}

export function getItemQuantityInCart(item, cartItemDetails) {
  let itemInCart = cartItemDetails?.filter(
    (it) => it?.item_id === item?.item_id
  );
  let itemInComboItemsInCart = cartItemDetails?.reduce((pre, cur) => {
    if (cur?.is_combo) {
      pre = pre.concat(
        cur?.combo_items?.filter((it) => it?.item_id === item?.item_id) || []
      );
    }
    return pre;
  }, []);

  let itemQuantityInComboItemsInCart =
    itemInComboItemsInCart?.reduce((pre, cur) => {
      pre = pre + cur?.combo_item_quantity;
      return pre;
    }, 0) || 0;

  let itemQuantityInCart =
    itemInCart?.reduce((pre, cur) => {
      pre = pre + cur?.quantity;
      return pre;
    }, 0) || 0;

  let itemQuantityAslinkedItemInCart = getLinkedItemQuantityInCart(
    item,
    cartItemDetails
  );
  return (
    itemQuantityInCart +
    itemQuantityInComboItemsInCart +
    itemQuantityAslinkedItemInCart
  );
}

export function getAddonQuantityInCart(addon, cartItemDetails) {
  let addonInCart = cartItemDetails?.reduce((pre, cur) => {
    if (cur?.is_combo) {
      let addonInComboItems = cur?.combo_items?.reduce((prev, curr) => {
        if (curr?.addons) {
          let addonInCurComboItem = curr?.addons?.filter(
            (add) =>
              add?.addon_id === addon?.addon_id ||
              (add?.linked_item_id &&
                addon?.linked_item_id &&
                add?.linked_item_id === addon?.linked_item_id)
          );
          prev = prev.concat(addonInCurComboItem);
        }
        return prev;
      }, []);
      pre = pre.concat(addonInComboItems);
    } else {
      if (cur?.addons) {
        let addonInCurItem = cur?.addons?.filter(
          (add) =>
            add?.addon_id === addon?.addon_id ||
            (add?.linked_item_id &&
              addon?.linked_item_id &&
              add?.linked_item_id === addon?.linked_item_id)
        );
        pre = pre.concat(addonInCurItem);
      }
    }
    return pre;
  }, []);

  let addonQuantityInCart =
    addonInCart?.reduce((pre, cur) => {
      pre = pre + cur?.addon_quantity;
      return pre;
    }, 0) || 0;

  return addonQuantityInCart;
}

export function getAddedComboGroupItemsQuantity(
  comboGroup,
  selectedComboItems
) {
  let curGroupItems = selectedComboItems?.filter(
    (item) => item?.combo_group_id === comboGroup?.combo_group_id
  );
  let quantity = curGroupItems?.reduce((pre, cur) => {
    pre = pre + cur?.item_quantity;
    return pre;
  }, 0);

  return quantity;
}

export const COLLECTION_LABEL_PROPERTY_ID =
  "Prop_85eb0f3914844dfdb1b4e3f6465a75dc";

/**
 * Fold the QR-storefront-only appearance overrides (`qr_theme` on fetch-property) onto the
 * property, so every screen — MUI palette, header logo, order-type buttons — picks them up without
 * knowing they exist.
 *
 * Applied at the single point the property enters this app rather than at each render site,
 * because the underlying fields are shared: `theme` is the Self-Service Kiosk's theme, and
 * `dine_in_label`/`take_away_label`/`property_image` are also read by the online-ordering
 * storefront and Kayana Eats. Overriding them HERE keeps the change inside the QR app.
 *
 * Every key is optional — a property that has never opened Appearance in Partners Admin gets its
 * existing values back untouched.
 */
export function applyQrTheme(property) {
  const qrTheme = property?.qr_theme;
  if (!qrTheme) return property;

  const labels = qrTheme.order_type_labels || {};
  const icons = qrTheme.order_type_icons || {};
  return {
    ...property,
    ...(qrTheme.base_colour
      ? { theme: { ...property.theme, base_colour: qrTheme.base_colour } }
      : {}),
    ...(qrTheme.logo_image ? { property_image: qrTheme.logo_image } : {}),
    ...(qrTheme.order_confirmation_image
      ? { order_confirmation_image: qrTheme.order_confirmation_image }
      : {}),
    ...(labels.dine_in ? { dine_in_label: labels.dine_in } : {}),
    ...(labels.take_away ? { take_away_label: labels.take_away } : {}),
    ...(labels.delivery ? { delivery_label: labels.delivery } : {}),
    ...(icons.dine_in ? { dine_in_image: icons.dine_in } : {}),
    ...(icons.take_away ? { take_away_image: icons.take_away } : {}),
    ...(icons.delivery ? { delivery_image: icons.delivery } : {}),
    ...(qrTheme.table_number_label ? { table_number_label: qrTheme.table_number_label } : {}),
    ...(qrTheme.room_number_label ? { room_number_label: qrTheme.room_number_label } : {}),
  };
}

export function getOrderTypeLabel(orderType, restaurant) {
  const orderTypeMap = {
    "TAKE AWAY": "take_away_label",
    "DINE IN": "dine_in_label",
  };

  const label = restaurant?.[orderTypeMap[orderType]] || orderType;
  const isTargetProperty =
    restaurant?.property_id === COLLECTION_LABEL_PROPERTY_ID;
  return isTargetProperty && orderType === "TAKE AWAY" ? "Collection" : label;
}

// A main item priced at £0 (real price lives on its size/addon options) shows only its name,
// matching the kiosk. Anything that isn't a positive amount counts as zero.
export const isZeroPrice = (value) => !(parseFloat(value) >= 0.01);

export const validateRequired = (value) =>
  value ? null : "Table number is required";

export const requiredField = (label) => (value) =>
  value ? null : `${label} is required`;

export const validateEmail = (value) =>
  !value || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    ? null
    : "Enter a valid email";

export const validatePhone = (value) =>
  value && value.replace(/\D/g, "").length >= 8
    ? null
    : "Enter a valid phone number";

export const stripLeadingZeroAfterDialCode = (value) =>
  (value || "").replace(/^440/, "44");

export const composeValidators =
  (...validators) =>
  (value) =>
    validators.reduce(
      (error, validator) => error || validator(value),
      undefined
    );

export const timeConvert = (time) => {
  time = time
    ?.toString()
    ?.match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (time?.length > 1) {
    // If time format correct
    time = time?.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time?.join(""); // return adjusted time or original string
};

export function useUpsellItemsList() {
  const {
    sessionDetails: { username },
    cart_id,
    selectedFilters,
  } = useSession();

  const { data, isLoading } = useCartDetailsAction({
    cart_id: cart_id,
    username: username,
    ...selectedFilters,
  });

  const upsellItems = useMemo(() => {
    // Using a Set to track unique item_ids
    const uniqueItems = new Set();

    return data?.data?.data?.cart_item_details?.reduce((pre, cur) => {
      if (cur?.upsell_items_list?.length) {
        // Filter out duplicate items based on item_id
        const filteredItems = cur?.upsell_items_list.filter((item) => {
          if (!uniqueItems.has(item.item_id)) {
            uniqueItems.add(item.item_id); // Add item_id to the Set
            return true;
          }
          return false;
        });
        return [...pre, ...filteredItems];
      } else {
        return pre;
      }
    }, []);
  }, [data]);

  return { data: upsellItems, isLoading };
}
